import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from '../_services/auth.service';
import { LanguageService } from '../_services/language.service';

interface Breadcrumb {
    label: string;
    url?: string;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html',
})
export class AppBreadcrumbComponent implements OnInit {
    isRefreshed = true; // dummy variable flag

    private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);

    readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

    constructor(private router: Router,
        public lang:LanguageService,
        private activatedRoute: ActivatedRoute) {
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd )).subscribe(event => {
            this.isRefreshed = false;
            const root = this.router.routerState.snapshot.root;
            const breadcrumbs: Breadcrumb[] = [];
            this.addBreadcrumb(root, [], breadcrumbs);

            this._breadcrumbs$.next(breadcrumbs);
        });
    }

    ngOnInit(): void {
        if (this.isRefreshed) {
            this.isRefreshed = false;
            const breadcrumbs: Breadcrumb[] = [];
            this.addBreadcrumb(this.activatedRoute.snapshot.root, [], breadcrumbs);
            this._breadcrumbs$.next(breadcrumbs);
        }
    }

    private addBreadcrumb(route: ActivatedRouteSnapshot, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
        const routeUrl = parentUrl.concat(route.url.map(url => url.path));
        const breadcrumb = route.data['breadcrumb'];
        const parentBreadcrumb = route.parent && route.parent.data ? route.parent.data['breadcrumb'] : null;

        if (breadcrumb && breadcrumb !== parentBreadcrumb) {
            breadcrumbs.push({
                label: this.lang.el(route.data['breadcrumb']),
                url: '/' + routeUrl.join('/')
            });
        }

        if (route.firstChild) {
            this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
        }
    }

}
